import React, { Component } from "react";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as orderActions from '../Actions/orderActions';
import NonconformityList from "../Components/Nonconformity/NonconformityList";
import { orderService } from "../Services/OrderService.js";
import {searchFilterService} from "../Services/SearchFilterService.js";

class NonconformityListConteiner extends Component {
	constructor(props){
		super(props);
	}
//	componentDidMount() {
//	}
	
	render() {
	    return (<NonconformityList	nonconformityRecordOrders={this.props.nonconformityRecordOrders}/>);
	}
}

function mapStateToProps(state, ownProps) {  
	return {nonconformityRecordOrders: searchFilterService.objectFilter(state.orders, (order => {return ((typeof order.nonconformity !== 'undefined') && (order.nonconformity!==null) );})),
			user: state.user}
}

function mapDispatchToProps(dispatch) {  
	return {actions: bindActionCreators(orderActions, dispatch)}
}

export default connect(mapStateToProps, mapDispatchToProps)(NonconformityListConteiner);  